import { AgActionCellRendererComponent } from "../../../../../core/components/grid-wrapper/helper/ag-action-cell-renderer/ag-action-cell-renderer.component";
import {
  Component,
  OnInit,
  Input,
  ViewChild,
} from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { GatePassRequestsService } from "../../../gate-pass-requests.service";
import { AssociateEffectiveDateCellRendererComponent } from "../../../ag-helper/associate-resign-date-cell-renderer/associate-resign-date-cell-renderer.component";
import { LogHelperService } from "src/app/core/services/log-helper.service";
import { editButtonRenderer } from "../../../ag-helper/htmlElement/buttonElement.component";
import { AbstractControl, FormArray, FormBuilder, FormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { SharedService } from "src/app/core/services";
import { GLOBAL } from "src/app/app.globals";

@Component({
  selector: "app-popup-workman-salary-master",
  templateUrl: "./popup-workman-salary-master.component.html",
  styleUrls: ["./popup-workman-salary-master.component.css"],
  host: {
    class: "h-100 overflow-hidden d-flex flex-column",
  },
})
export class PopupWorkmanSalaryMasterComponent implements OnInit {
  private pRowData: any;
  private wageDetails: any;
  isCeilingAmountDisabled: boolean = true;
  @Input() public set rowData(value: any) {
    if (value) {
      this.pRowData = value;
      if (this.wageDetails) {
        this.setControlValues(value.data);
      }
      // this.setControlValues(value.data);
    }
  }
  @ViewChild(editButtonRenderer) editButtonRenderer;

  public get rowData(): any {
    return this.pRowData;
  }

  @Input() public set checkMinWage(value: any) {
    if (value) {
      this.wageDetails = value;
      console.log("wageDetails",this.wageDetails);
      if (this.pRowData && this.pRowData.data) {
        this.setControlValues(this.pRowData.data);
      }
    }
  }
  public get checkMinWage(): any {
    return this.wageDetails;
  }

  public formGroup: FormGroup;
  public greaterThan: boolean[] = [];

  public get salaryDetails(): FormArray {
    return this.formGroup.get("salaryDetails") as FormArray;
  }
  constructor(
    public sharedService: SharedService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private _gatePassRequestsService: GatePassRequestsService,
    private logHelperService: LogHelperService
  ) {
    this.formGroup = this.fb.group({
      salaryDetails: this.fb.array([]),
      epfCalculation: [0],
      ceilingAmount: ['', [Validators.pattern(/^\d+$/)], null, [Validators.required, this.ceilingAmountValidator(15000)]],
      ceilingAmountDate: ['', Validators.required],
    });
  }

  ngOnInit() {
    this.checkMinWage = this.checkMinWage || []; 
    if (this.isCeilingAmountDisabled) {
      this.formGroup.get('ceilingAmount').disable();
    }

    this.rowData.data.forEach((item) => {
      if (item.Component_Code === 114) {
        if (item.Amount === 1) {
          this.formGroup.get('epfCalculation').setValue(1);
          this.formGroup.get('ceilingAmount').enable();
          this.isEnableComponent();
        }
      }
    })
    // this.salaryDetails.controls.forEach((group: FormGroup, index: number) => {
    //   group.valueChanges.subscribe((value) => {
    //     const minWageAmount = this.checkMinWage[index];
    //     if (value.Amount >= minWageAmount.Amount) {
    //       this.greaterThan[index] = false;
    //     } else {
    //       this.greaterThan[index] = true;
    //     }
    //   });
    // });
    this.salaryDetails.controls.forEach((group: FormGroup, index: number) => {
      group.valueChanges.subscribe((value) => {
        if (Array.isArray(this.checkMinWage) && this.checkMinWage.length > index) {
          const minWageAmount = (this.checkMinWage[index] && typeof this.checkMinWage[index].Amount !== 'undefined')
            ? this.checkMinWage[index].Amount
            : 0;

          if (value.Amount >= minWageAmount && value.Amount >= 0) {
            this.greaterThan[index] = false;
          } else {
            this.greaterThan[index] = true;
          }
        } else {
          console.error("checkMinWage is not a valid array or index is out of bounds");
        }
      });
    });
  }

  isEnableComponent() {
    this.rowData.data.forEach((item) => {
      if (item.Component_Code === 115) {
        this.formGroup.get('ceilingAmount').setValue(item.Amount);
      }
    })
  }

  ceilingAmountValidator(minValue: number): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const value = control.value;
      if (value !== null && value < minValue) {
        return { minValue: { requiredValue: minValue, actualValue: value } };
      }
      return null;
    };
  }

  onDropdownChange(data): void {
    if (data == 1) {
        this.formGroup.get('ceilingAmount').enable();
        this.formGroup.get('ceilingAmount').setValue(15000);
        this.isCeilingAmountDisabled = false;
        this.formGroup.get('ceilingAmountDate').setValidators([Validators.required]);
    } else if (data == 0) {
        this.formGroup.get('ceilingAmount').disable();
        this.formGroup.get('ceilingAmount').reset();
        this.isCeilingAmountDisabled = true;

        this.formGroup.get('ceilingAmountDate').clearValidators();
    }

    this.formGroup.get('ceilingAmountDate').updateValueAndValidity();
}

  onCheckboxChange(form: FormGroup): void {
    const isSelected = form.get("isSelected").value;
    if (isSelected) {
      form.get("Amount").enable();
      form.get("EffectiveDate").enable();
      form.get("Amount").setValidators([Validators.required]);
      form.get("EffectiveDate").setValidators([Validators.required]);
    } else {
      form.get("Amount").disable();
      form.get("EffectiveDate").disable();
      form.get("Amount").clearValidators();
      form.get("EffectiveDate").clearValidators();
    }
  }

  checkValidation(form: FormGroup, controlName: string): boolean {
   
    if (!form || !form.get(controlName)) {
      return false;
    }
    const control = form.get(controlName);
    return control.invalid && (control.dirty || control.touched);
  }

  isInvalidNumber(group: FormGroup, controlName: string): boolean {
    const control = group.get(controlName);
    if (!control) return false;

    const value = control.value;
    if (value === null || value === '') {
    return true;
    }

    const numericValue = Number(value);

    // not a number OR negative (allow zero)
    return isNaN(numericValue) || numericValue < 0;
  }

  // checkValidationSuccess(form: FormGroup, controlName: string): boolean {
    
  //   if (form.valid || form.get(controlName).valid) return true;
  //   return false;
  // }
  checkValidationSuccess(form: FormGroup, controlName: string): boolean {
    if (!form || !form.get(controlName)) {
      return false;
    }

    const control = form.get(controlName);
    const value = Number(control.value);

    return (
      control.valid &&
      (control.dirty || control.touched) &&
      value >= 0
    );
  }
  
  invalidDateValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    // ❌ Required
    if (!value) {
      return { required: true };
    }

    // ❌ Block "0"
    if (value === '0') {
      return { invalidFormat: true };
    }

    // ✅ Picker value (Moment)
    if (moment.isMoment(value)) {
      return value.isValid() ? null : { invalidFormat: true };
    }

    // ✅ Native Date
    if (value instanceof Date) {
      return isNaN(value.getTime()) ? { invalidFormat: true } : null;
    }

    // ❌ Manual typing (string)
    if (typeof value === 'string') {

      // 🔥 STRICT DD-MM-YYYY pattern (blocks 09-, 09-1, etc.)
      if (!/^\d{2}-\d{2}-\d{4}$/.test(value)) {
        return { invalidFormat: true };
      }

      const parsed = moment(value, 'DD-MM-YYYY', true);

      if (!parsed.isValid()) {
        return { invalidFormat: true };
      }

      // ✅ Normalize to Moment
      control.setValue(parsed, { emitEvent: false });
      return null;
    }

    return { invalidFormat: true };
  };
}

  saveAllDataButton() {
    if (!this.formGroup.valid) {
      const invalidFields: string[] = [];

      for (const formGroup of this.salaryDetails.controls) {
        formGroup.get("Amount").markAsDirty();
        formGroup.get("Amount").markAsTouched();
        formGroup.get("Amount").updateValueAndValidity();

        formGroup.get("EffectiveDate").markAsDirty();
        formGroup.get("EffectiveDate").markAsTouched();
        formGroup.get("EffectiveDate").updateValueAndValidity();

        // if (!formGroup.get("EffectiveDate").value) {
        //   invalidFields.push('EffectiveDate');
        // }
        const effCtrl = formGroup.get("EffectiveDate");

        if (effCtrl.invalid) {
          invalidFields.push('EffectiveDate');
        }
      }

      const epfCalculationValue = this.formGroup.get('epfCalculation').value;
      const ceilingAmountDate = this.formGroup.get('ceilingAmountDate').value;

      if (epfCalculationValue === 1 && !ceilingAmountDate) {
        this.logHelperService.logError({
          message: "Ceiling Amount Effective Date is required when EPF Calculation is set to 'Yes'.",
        });
        return;
      }

      if (invalidFields.includes('EffectiveDate')) {
        this.logHelperService.logError({
          message: "Effective Date is required.",
        });
        return;
      }

      this.logHelperService.logError({
        message: "Amount and Effective date is required.",
      });

      return;
    }

    const controlValues = this.salaryDetails.getRawValue();

    const selectedValues = controlValues.filter((item) => item.isSelected);

    if (!selectedValues.length) {
      this.logHelperService.logError({
        message: "Please select at least one item.",
      });
      return;
    }

    const data = this.rowData.editObj;
    let finalList = controlValues.map((res) => ({
      UEC: data.GatePassNo || null,
      Component_Code: res.Component_Code,
      GatePassRequest_Code: data.GatePassRequest_Code,
      Plant_Code: data.Plant_Code,
      Contractor_Code: data.ContractoreVendor,
      Clinet_Code: null,
      EffectiveDate: res.EffectiveDate,
      Amount: res.Amount,
      UserId: GLOBAL.USER_ID,
      Salary_Code: res.HandEntryValueId || null,
    }));

    if (this.rowData.editObj) {
      const ceilingAmountDate = this.formGroup.get('ceilingAmountDate').value || null;
      const amount = this.isCeilingAmountDisabled ? 0 : this.formGroup.get('ceilingAmount').value;

      const additionalItems = this.removedItems.map((item) => ({
        UEC: data.GatePassNo || null,
        Component_Code: item.Component_Code,
        GatePassRequest_Code: data.GatePassRequest_Code,
        Plant_Code: data.Plant_Code,
        Contractor_Code: data.ContractoreVendor,
        Clinet_Code: null,
        EffectiveDate: ceilingAmountDate,
        Amount: item.Component_Code === 114 ? (this.isCeilingAmountDisabled ? 0 : 1) : amount,
        UserId: GLOBAL.USER_ID,
        Salary_Code: item.Salary_Code || null,
      }));
      finalList = finalList.concat(additionalItems);
    }

    this._gatePassRequestsService.insertUpdatePayrollHandentry(finalList).subscribe((res: any) => {
      this.logHelperService.logSuccess({
        message: "Data saved successfully.",
      });
      this.activeModal.dismiss();
    });
  }


  onFillAllDates(index: number): void {
    const selectedDate = this.salaryDetails.at(index).get('EffectiveDate').value;

    if (!selectedDate) {
      this.logHelperService.logError({
        message: 'Please select a date in the current row first.',
      });
      return;
    }

    for (let i = index + 1; i < this.salaryDetails.length; i++) {
      this.salaryDetails.at(i).patchValue({
        EffectiveDate: selectedDate,
      });
    }
    this.formGroup.patchValue({
      ceilingAmountDate: selectedDate,
    });
  }


  getTotalAmount(): number {
    let total = this.salaryDetails.controls
      .map((group) => parseFloat(group.get("Amount").value) || 0)
      .reduce((sum, current) => sum + current, 0);

    // if (!this.isCeilingAmountDisabled) {
    //   const ceilingAmount = parseFloat(this.formGroup.get("ceilingAmount").value) || 0;
    //   total += ceilingAmount;
    // }

    return total;
  }

  removedItems: any[] = []
  setControlValues(list: any): void {
  const removedItems = list.filter((item: any) =>
    item.Short_Code === "PF_CEILING" || item.Short_Code === "PF_CEILING_AMOUNT"
  );

  const remainingItems = list.filter((item: any) =>
    item.Short_Code !== "PF_CEILING" && item.Short_Code !== "PF_CEILING_AMOUNT"
  );

  const control = this.formGroup.get("salaryDetails") as FormArray;
  control.controls = [];

  for (const task of remainingItems) {
    const formGroup: any = this.buildForm(task);
    control.push(formGroup);
  }

  this.removedItems = removedItems;
  
  // Trigger validation after a short delay
  setTimeout(() => {
    control.controls.forEach((group: FormGroup) => {
      group.get('Amount').updateValueAndValidity();
      group.get('EffectiveDate').updateValueAndValidity();
    });
  }, 100);
}

isLessThanMinWage(group: FormGroup): boolean {
  const amount = Number(group.get('Amount').value);
  const minWage = Number(group.get('minWageAmount').value);

  if (!amount || !minWage) return false;

  return amount < minWage;
}
  buildForm(data: any): FormGroup {
  const isExist = !!data.HandEntryValueId;
  
  // Find matching checkMinWage item by Component_Code
  const matchingMinWage = this.checkMinWage && this.checkMinWage.find
    ? this.checkMinWage.find((wage: any) => wage.Component_Code === data.Component_Code)
    : null;
  
  // Use checkMinWage Amount if rowData Amount is null, default to 0
  const displayAmount = data.Amount != null 
    ? data.Amount 
    : (matchingMinWage && matchingMinWage.Amount != null ? matchingMinWage.Amount : 0);
  
  // Parse EffectiveDate string to Moment object
  let effectiveDate = data.EffectiveDate;
  let hasPrefilledDate = false;
  if (effectiveDate && typeof effectiveDate === 'string') {
    const parsedDate = moment(effectiveDate, 'DD-MM-YYYY', true);
    if (parsedDate.isValid()) {
      effectiveDate = parsedDate;
      hasPrefilledDate = true;
    }
  }

  const minWageAmount =
  matchingMinWage && matchingMinWage.Amount != null
    ? matchingMinWage.Amount
    : 0;
  
  const formGroup = this.fb.group({
    isSelected: [{ value: !isExist, disabled: !isExist }],
    ShortName: [
      { value: data.ShortName, disabled: isExist },
      !isExist ? [Validators.required] : undefined,
    ],
    Amount: [
      { value: displayAmount, disabled: isExist }, 
      !isExist ? [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/), Validators.min(0)] : undefined,
    ],
    EffectiveDate: [
      { value: effectiveDate, disabled: isExist },
      !isExist ? [Validators.required, this.invalidDateValidator()] : undefined,
    ],
    UEC: [data.GatePassNo],
    Component_Code: [data.Component_Code],
    HandEntryValueId: [data.HandEntryValueId || null],
    hasPrefilledDate: [hasPrefilledDate], // Track if date was prefilled

    minWageAmount: [minWageAmount],
  });

  // Mark fields as touched and dirty if they have values
  if (!isExist && displayAmount != null) {
    formGroup.get('Amount').markAsTouched();
    formGroup.get('Amount').markAsDirty();
  }
  
  if (!isExist && hasPrefilledDate) {
    formGroup.get('EffectiveDate').markAsTouched();
    formGroup.get('EffectiveDate').markAsDirty();
  }

  return formGroup;
}
}
